import React, { FC } from 'react';
import classNames from 'classnames';
import { Flex, TextComponent } from '@monorepo/react-components';
import { useResponsiveness } from '@monorepo/react-hooks';

import styles from './affiliation-partner-card.module.scss';

interface Props {
  partner: {
    icon: any;
    title: string;
    description: string;
  };
}

const AffiliationPartnerCard: FC<Props> = ({ partner }) => {
  const { isMobile } = useResponsiveness();
  return (
    <Flex
      className={classNames(styles.partnerCard, { [styles.mobile]: isMobile })}
    >
      <partner.icon className={styles.partnerIcon} />
      <Flex vertical gap={10}>
        <TextComponent level={4} weight={600}>
          {partner.title}
        </TextComponent>
        <TextComponent level={7} weight={400}>
          {partner.description}
        </TextComponent>
      </Flex>
    </Flex>
  );
};

export default AffiliationPartnerCard;
